const CopyReportIcon = ({ copyAllowed }) => {
  const basePath = `${window.location.origin}/images`;
  return (
    <img
      src={
        copyAllowed
          ? `${basePath}/copy-icon-select.png`
          : `${basePath}/copy-icon-default.png`
      }
      alt="Copy Report"
      style={{width: 25, height: 25 , border : '2px solid white'}}
    />
  );
};

export default CopyReportIcon;

